import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";
import PrivateRoute from "./privateRoute";
import models from "../model-declaration";
import Dashbaord from "../modules/dashboard";
import ListPage from "../modules/list";
import ViewPage from "../modules/read";
import Createpage from "../modules/create";
import Editpage from "../modules/edit";
import ProtectedRoute from "./protectedRoute";
import LoginPage from "../modules/auth/login";
import CreateUsers from "../modules/admin/users/create-users";
import ListUsers from "../modules/admin/users/list-users";
import ReadUsers from "../modules/admin/users/read-users";
import EditUsers from "../modules/admin/users/edit-users";
import ListBlogs from "../modules/blogs/list-blogs";
import CreateBlogs from "../modules/blogs/create-blogs";
import EditBlogs from "../modules/blogs/edit-blogs";
import ReadBlogs from "../modules/blogs/read-blogs";
import ReadCity from "../modules/city/read-city";
import CreateNewsletter from "../modules/newsletter/create-newsletter";
import EditNewsletter from "../modules/newsletter/edit-newsletter";
import ReadNewsletter from "../modules/newsletter/read-newsletter";
import ListNewsletter from "../modules/newsletter/list-newsletter";

const MainRoutes = () => {
  return (
    <Router>
      <Routes>
        <Route element={<PrivateRoute />}>
          <Route path="/dashboard" element={<Dashbaord />} />
          {/* ------ AADMIN USERS ------ */}
          <Route path="/admin/users/list" element={<ListUsers />} />
          <Route path="/admin/users/create" element={<CreateUsers />} />
          <Route path="/admin/users/view/:id" element={<ReadUsers />} />
          <Route path="/admin/users/edit/:id" element={<EditUsers />} />
          <Route path="/blogs/list" element={<ListBlogs />} />
          <Route path="/blogs/create" element={<CreateBlogs />} />
          <Route path="/blogs/view/:id" element={<ReadBlogs />} />
          <Route path="/blogs/edit/:id" element={<EditBlogs />} />
          <Route path="/city/view/:id" element={<ReadCity />} />

          <Route path="/newsletter_display/list" element={<ListNewsletter />} />
          <Route
            path="/newsletter_display/create"
            element={<CreateNewsletter />}
          />
          <Route
            path="/newsletter_display/edit/:id"
            element={<EditNewsletter />}
          />
          <Route
            path="/newsletter_display/view/:id"
            element={<ReadNewsletter />}
          />
          {models?.map((model) => (
            <React.Fragment>
              <Route
                path={`/${model.tableName}/list`}
                element={<ListPage model={model} />}
              />
              <Route
                path={`/${model.tableName}/view/:id`}
                element={<ViewPage model={model} />}
              />
              <Route
                path={`${model.tableName}/create`}
                element={<Createpage model={model} />}
              />
              <Route
                path={`${model.tableName}/edit/:id`}
                element={<Editpage model={model} />}
              />
            </React.Fragment>
          ))}
        </Route>
        <Route element={<ProtectedRoute />}>
          <Route path={`/`} element={<LoginPage />} />
        </Route>
      </Routes>
    </Router>
  );
};

export default MainRoutes;
